module.exports = __webpack_public_path__ + "static/img/our-people-our-investment-worldwide.1853417.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-our-investment-worldwide.jpg
// module id = B2f3
// module chunks = 0